interface Map<T> {
    [K: string]: T;
}

export const ComponentNames: Map<string> = {}
ComponentNames["SectionTemplate"] = "Section Template";
ComponentNames["DataFieldTemplate"] = "Section Header Item Template";
ComponentNames["EntryGroupTemplate"] = "Personnel List Template";
ComponentNames["ListingGroupTemplate"] = "Custom List Template";